import { render, staticRenderFns } from "./TicketsReportingTable.vue?vue&type=template&id=59c992c6&scoped=true&"
import script from "./TicketsReportingTable.vue?vue&type=script&lang=js&"
export * from "./TicketsReportingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c992c6",
  null
  
)

export default component.exports